import { useState, useEffect } from "react";
// // import Pagination from "rc-pagination";
import Modal from "./AddNew";
import { Link } from "react-router-dom";
import { WithSuperAuth } from "../S-Overview";
import { HOST_URL, reqOptions } from "../../../assets/js/helpFunction";
import { MssgContainer } from "../../../components/partials/utils";
import "./superadmin-estates.css";
const EstateIcon = ({ name, size = 18 }) => {
  const paths = {
    estate: "M3 21h18M5 21V9l7-5 7 5v12M9 21v-6h6v6",
    plus: "M12 5v14M5 12h14",
    location: "M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    arrow: "M5 12h14m-5-5 5 5-5 5",
    empty: "M4 21h16M6 21V8l6-4 6 4v13M9 11h.01M15 11h.01M9 15h.01M15 15h.01",
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d={paths[name]} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
};

const Estate = () => {
  const [estates, setEstates] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(1);

  const [mssg, setMssg] = useState({ error: false, mssg: "" });

  const closeMssg = () => {
    setMssg({ error: false, mssg: "" });
  };
  const handleClick = (status, index) => {
    setActiveIndex(index);
    const requestOptions = reqOptions("get", null, true);
    const estates_api = `${HOST_URL()}estates/super_admin/${
      status && "?status=" + status
    }`;
    fetch(estates_api, requestOptions)
      .then((res) => res.json())
      .then((response) => setEstates(response.results))
      .catch((err) => console.log(err));
  };
  const checkActive = (index, className) =>
    activeIndex === index ? className : "";

  useEffect(() => {
    const requestOptions = reqOptions("get", null, true);
    const estates_api = `${HOST_URL()}estates/super_admin/`;
    fetch(estates_api, requestOptions)
      .then((res) => res.json())
      .then((response) => {
        setEstates(response.results);
      })
      .catch((err) => console.log(err));
  }, []);

  const ActivateEstate = (estate) => {
    const modifyURL = `${HOST_URL()}estates/super_admin/${estate.estate_id}/`;
    const status = estate.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    const requestOptions = reqOptions("put", JSON.stringify({ status }), true);
    fetch(modifyURL, requestOptions)
      .then((res) => res.json())
      .then((response) => {
        if (response.id) {
          setMssg({
            ...mssg,
            mssg: `Estate ${
              status.toLocaleLowerCase() === "active"
                ? "activated"
                : "deactivated"
            } successfully`,
          });
          const edited_data = estates.map((item) => {
            if (item.id == response.id) {
              return { ...item, status: response.status };
            }
            return item;
          });
          setEstates(edited_data);
        } else {
          setMssg({ ...mssg, mssg: response.detail });
        }
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  };

  return (
    <WithSuperAuth activeSection="estate">
      <main className="super-estates-page">
        {mssg.mssg && <MssgContainer mssg={mssg} close={closeMssg} />}
        <header className="super-estates-header"><div><p className="super-estates-kicker"><EstateIcon name="estate" /> PLATFORM ESTATES</p><h1>Estate management</h1><p>Review every registered estate, open its profile and control platform access.</p></div><button type="button" className="super-estates-add" onClick={() => setOpenModal(true)}><EstateIcon name="plus" /> Add New Estate</button></header>

      <section className="estates_tab super-estates-registry">
        <div className="super-estates-registry-head"><div><h2>Estate registry</h2><p>{estates.length} estate{estates.length === 1 ? "" : "s"} in the selected view</p></div></div>
        <div className="adding_new super-estates-toolbar">
          <div className="tabs">
            <button
              className={`tab ${checkActive(1, "active")}`}
              onClick={() => handleClick("", 1)}
            >
              All estates
            </button>
            <button
              className={`tab ${checkActive(2, "active")}`}
              onClick={() => handleClick("ACTIVE", 2)}
            >
              Active
            </button>
            <button
              className={`tab ${checkActive(3, "active")}`}
              onClick={() => handleClick("INACTIVE", 3)}
            >
              Inactive
            </button>
          </div>
        </div>

        {/* RESULT FROM TAB */}
        <div className="panels flex_2">
          <div className={`panel active`}>
            <div className="threecards_grid estate_cards">
              {estates && estates.length ? (
                estates.map((estate) => (
                  <article className="per_estate super-estate-card" key={estate.id}>
                    <Link to={`/superadmin/estates/${estate.estate_id}`}>
                      <div className="super-estate-card-top"><span className={`super-estate-status ${estate.status?.toLowerCase()}`}>{estate.status === "ACTIVE" ? "Active" : "Inactive"}</span><span className="super-estate-days">{estate.days_left}</span></div>
                      <div className="name_id">
                        <h2>{estate.name}</h2>
                        <p>{estate.estate_id}</p>
                      </div>
                      <h3>{estate.estate_type?.replaceAll("_", " ")}</h3>
                      <div className="super-estate-location"><EstateIcon name="location" size={15} /><p>{estate.address}</p></div>
                      <span className="super-estate-view">View estate profile <EstateIcon name="arrow" size={15} /></span>
                    </Link>
                    <div className="super-estate-control">
                      <div><strong>Estate access</strong><span>{estate.status === "ACTIVE" ? "Enabled" : "Disabled"}</span></div>
                      <div className="checkbox_item citem_1">
                        <label className="checkbox_wrap">
                          <input
                            type="checkbox"
                            name="checkbox"
                            class="checkbox_inp"
                            checked={estate.status === "ACTIVE" ? true : false}
                            onChange={() => ActivateEstate(estate)}
                          />
                          <span className="checkbox_mark"></span>
                        </label>
                      </div>
                    </div>
                  </article>
                ))
              ) : (
                <div className="super-estates-empty"><EstateIcon name="empty" size={27} /><strong>No estates found</strong><span>There are no estates in this status group yet.</span><button type="button" onClick={() => setOpenModal(true)}>Add an estate</button></div>
              )}
            </div>
          </div>
        </div>
      </section>
      <Modal open={openModal} onClose={() => setOpenModal(false)} />
      </main>
    </WithSuperAuth>
  );
};

export default Estate;
